// extracted by mini-css-extract-plugin
export default {"containerTable":"TableComponent_containerTable__AYwFc","totals":"TableComponent_totals__0DIy+"};